import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import personFill from '@iconify/icons-eva/person-fill';
import clockOutline from '@iconify/icons-eva/clock-outline';
import printerOutline from '@iconify/icons-eva/printer-outline';
import paperPlaneOutline from '@iconify/icons-eva/paper-plane-outline';
import settings2Outline from '@iconify/icons-eva/settings-2-outline';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import SettingsIcon from '@material-ui/icons/Settings';
import { Link as RouterLink } from 'react-router-dom';

import { alpha } from '@material-ui/core/styles';
import { Button, Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@material-ui/core';

import MenuPopover from '../../components/MenuPopover';

const MENU_OPTIONS = [
  {
    label: 'Module Configuration',
    icon: settings2Fill,
    linkTo: '/settings/configmodules'
  },
  {
    label: 'Templates',
    icon: printerOutline,
    linkTo: '/settings/configtemplates'
  },
  {
    label: 'Scheduler',
    icon: clockOutline,
    linkTo: '/settings/configscheduler'
  },
  {
    label: 'Api Configuration',
    icon: paperPlaneOutline,
    linkTo: '/settings/configapis'
  },
  {
    label: 'User Management',
    icon: personFill,
    linkTo: '/settings/configmodules'
  },
  {
    label: 'Fin Configuration',
    icon: settings2Outline,
    linkTo: '/settings/configmodules'
  }
];

// ----------------------------------------------------------------------

export default function SettingsPopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        {/* <Avatar src={account.photoURL} alt="photoURL" /> */}
        <SettingsIcon sx={{ color: '#f44336' }} />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}
      </MenuPopover>
    </>
  );
}
